import VerivoxSetupModal from 'src/components/PromotionalIntegrations/Verivox/modals/setup/VerivoxSetupModal.svelte';
import type { ModalConfig } from 'src/types/Modals';
import { isEnergyPriceFeatureEnabled } from 'src/helpers/energy_price_helpers';
import { hasCompletedVerivoxLocation } from 'src/helpers/verivox_promo_helpers';

/**
 * Setup modal for Verivox energy price entry.
 * Pass `forceShow: true` for intentional opens (banner CTA, notification CTA)
 * so dismissals / partial profile data cannot silently block the modal.
 */
export const VerivoxSetupModalConfig = (forceShow = false): ModalConfig => ({
	id: 'energyPriceSetup',
	component: VerivoxSetupModal,
	props: {
		showModal: true,
	},
	rules: [
		{
			check: () => {
				if (forceShow) {
					return isEnergyPriceFeatureEnabled();
				}
				return isEnergyPriceFeatureEnabled() && !hasCompletedVerivoxLocation();
			},
			expected: true,
		},
	],
});

/** @deprecated Use VerivoxSetupModalConfig */
export const EnergyPriceSetupModalConfig = VerivoxSetupModalConfig;
